<template>
  <v-dialog
    v-model="modal"
    max-width="1000px"
    persistent
    no-click-animation
    @click:outside="$emit('close')"
    @close="$emit('close')">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="$store.state.auth.permission >= 2"
        outlined
        color="primary"
        dark
        class="mb-2"
        v-bind="attrs"
        v-on="on">
        {{ buttonText }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <h3>{{ title }}</h3>
      </v-card-title>
      <v-divider />
      <v-card-subtitle class="pa-5">
        実施者の情報を入力してください。<br />
        入力された情報は全て報告書に記載されます。
      </v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col
            cols="3"
            class="text-right">
            <h3
              v-if="roles"
              class="mb-2">
              {{ roles.filter(role => role.id === item.pivot.role_id)[0].name }}
            </h3>
          </v-col>
          <v-col cols="5">
            <h2>
              {{ item.name }}
            </h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="3"
            class="text-right font-weight-bold">
            担当箇所
          </v-col>
          <v-col cols="5">
            <v-text-field
              v-model="item.pivot.assigned_place"
              :error-messages="error['pivot.assigned_place']"
              outlined
              label="担当箇所"
              dense />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="3"
            class="text-right font-weight-bold">
            (NADA登録)<br />石綿調査診断士登録証
          </v-col>
          <v-col cols="5">
            <v-text-field
              v-model="item.pivot.main_license_code"
              :error-messages="error['pivot.main_license_code']"
              outlined
              label="石綿調査診断士登録証番号"
              dense />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="3"
            class="text-right font-weight-bold">
            その他の修了証
          </v-col>
          <v-col cols="5">
            <v-select
              v-model="item.pivot.other_license_type"
              outlined
              :items="licenseTypesWithOutNada"
              item-value="id"
              item-text="name"
              label="その他の修了証"
              dense />
            <v-text-field
              v-model="item.pivot.other_license_code"
              outlined
              :disabled="!item.pivot.other_license_type"
              label="修了証番号"
              dense />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="3"
            class="text-right font-weight-bold">
            連絡先
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="item.pivot.mobilephone"
              outlined
              label="携帯電話番号"
              dense />
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="item.pivot.telephone"
              outlined
              label="TEL"
              dense />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="default"
          @click="onCloseButtonClicked">
          閉じる
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          @click="onSaveButtonClicked">
          保存する
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'UserPicker',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => ({
        id: null,
        pivot: {},
      }),
    },
    items: {
      type: Array,
      default: () => ([]),
    },
    title: {
      type: String,
      default: '実施者の追加',
    },
    buttonText: {
      type: String,
      default: '追加',
    },
    roles: {
      type: Array,
      default: () => ([]),
    },
    licenseTypes: {
      type: Array,
      default: () => ([]),
    },
    isNew: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      users: [],
      license: '',
      licenseSelect: '',
      chacheUser: '',
      error: {},
    }
  },
  computed: {
    modal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    selectedUser() {
      const [users] = this.users.filter(u => u.id === this.item.id)
      return users
    },
    licenseTypesWithOutNada() {
      return this.licenseTypes.filter(type => type.id !== 1)
    },
    selectedLicenseUser() {
      const [users] = this.items.filter(u => u.id === this.item.id)
      return users
    },
  },
  watch: {
    'item.id': {
      handler(newVal) {
        if (!newVal) {
          return
        }
        if (this.selectedLicenseUser) {
          this.chacheUser = JSON.parse(JSON.stringify(this.selectedLicenseUser))
          this.item.pivot.main_license_code = this.selectedLicenseUser.pivot.main_license_code
          this.updateOtherLicenseCode(this.item.pivot.other_license_type)
          return
        }
        this.item.pivot.main_license_code = this.selectedUser.license1.code ?? ''
        this.updateOtherLicenseCode(this.item.pivot.other_license_type)
      },
    },
    'item.pivot.other_license_type': {
      handler(newVal) {
        this.updateOtherLicenseCode(newVal)
      },
    },
  },
  methods: {
    async validateItem() {
      try {
        await window.axios.post('/api/confirmations/staff', this.item)
        this.error = {}
        return true
      } catch (e) {
        if (e.response.status === 422) {
          this.error = e.response.data.errors
        }
      }
      return false
    },
    onCloseButtonClicked() {
      this.modal = false
      this.$emit('close', this.chacheUser)
    },
    async onSaveButtonClicked() {
      if (await this.validateItem()) {
        this.modal = false
        this.$emit('save', this.item)
      }
    },
    onClose() {
      this.modal = false
      this.$emit('close')
    },
    updateOtherLicenseCode(value) {
      this.item.pivot.other_license_code = this.selectedUser && this.selectedUser[`license${value}`]
        ? this.selectedUser[`license${value}`].code ?? ''
        : ''
    },
  },
}
</script>
